import React, { Component } from 'react';
import MessagesExport from "../../components/pages/outils/messages-export";
import WaitlistExport from "../../components/pages/outils/waitlist-export";
import { setPageTitle } from "../../functions/common";

class OutilsMessagesExport extends Component {
    constructor(props) {
        super(props);
        setPageTitle("Export des messages");
    }
    render() {
        return <div>
            <h2>Export des messages</h2>
            <MessagesExport />
            <h2>Export des listes d'attente</h2>
            <WaitlistExport />
        </div>
    }
}

export default OutilsMessagesExport;
